import { BonusPointsState } from '../../models/loyalty/bonus-points.state';
import {
  BonusPointsActions,
  GET_BONUS_POINTS,
  GET_BONUS_POINTS_SUCCESS,
  GET_BONUS_POINTS_ERROR
} from '../../actions/loyalty/actions-bonus-points';

export const bonusPointsState: BonusPointsState = {
  data: {
    requestId: '',
    number: 10,
    accumulated: 0,
    used: 0,
    available: 0,
    regular: 0,
    additional: 0,
    expired: 0,
    totalSegments: 0,
    totalSegmentsOk: 0,
    totalSegmentsPD: 0,
    edenredIsOff: 0,
    toBeExpired: null
  },
  code: 9,
  message: '',
  isLoading: false,
  loadingError: ''
};

/* eslint-disable */
export function reducersBonusPoints(state = bonusPointsState, action: BonusPointsActions): BonusPointsState {
  switch (action.type) {
    case GET_BONUS_POINTS:
      return { ...state, isLoading: true, loadingError: '' };

    case GET_BONUS_POINTS_SUCCESS:
      return { ...action.payload, isLoading: false, loadingError: '' };

    case GET_BONUS_POINTS_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    default:
      return state;
  }
}
